module.exports = __webpack_public_path__ + "static/media/high.675fd3cf.svg";